import { useAuthenticatedQuery } from "@/hooks/useAuthenticatedQuery";
import { getInscriptionStatus } from "@/services/inscription/getInscriptionStatus";
import { useUser } from "@/context/UserContext";
import { realityId } from "@/utils/reality-id";

export function useInscriptionStatus() {
  const { userInfo } = useUser();

  return useAuthenticatedQuery(
    ["inscription-status", String(realityId), userInfo?.id?.toString() ?? ""],
    () => getInscriptionStatus(),
    { enabled: !!userInfo?.id, retry: 1 }
  );
}
